import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const plus: ISVGPersonalProps = {
  viewBox: '0 0 20.974 20.974',
  fill: 'currentColor',
  content: (
    <>
      <path
        id="Path_57"
        data-name="Path 57"
        d="M14.91,7.2a1.1,1.1,0,0,1,1.1,1.1v5.507h5.507a1.1,1.1,0,1,1,0,2.2H16.012v5.507a1.1,1.1,0,1,1-2.2,0V16.012H8.3a1.1,1.1,0,0,1,0-2.2h5.507V8.3A1.1,1.1,0,0,1,14.91,7.2Z"
        transform="translate(-4.423 -4.423)"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path id="Path_58" data-name="Path 58" d="M0,0H20.974V20.974H0Z" fill="none" />
    </>
  ),
};
